import './products.component.js';
import './works.component.js';
import './faq.component.js';

/*
import './founders.component.js';
import './specialisms.component.js';
import './contact.component.js';*/
